import { FullWindowOverlay } from 'react-native-screens'

export default FullWindowOverlay
